import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 绑定到分组
export function webBind(param,callback){
	request({
			method: 'post',
			url: 'FriendGroupRel/bind',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取当前管理员下粉丝分组信息
export function webGetAllFriendGroupRel(callback){
	request({
			method: 'post',
			url: 'FriendGroupRel/getAll',
			data: {
				manager_id : getLoginId(),
				client_type: 1
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}